import { useEffect, useState } from "react";
import Api from "../Api/Api.json";
import api from "../Api/base";
import { setLoading } from "../App";
import { parse, format } from "date-fns";
import { Pagination, Paper } from "@mui/material";

const AppointmentRequests = () => {
	const [requests, setRequests] = useState([
		// {
		// 	date: "2025-03-12 03:46:13",
		// 	name: "Test User",
		// 	phone: "9517420283",
		// 	specialization: "Urologist",
		// 	problems: '["problem1","problem2"]',
		// },
		// {
		// 	date: "2025-03-12 03:48:06",
		// 	name: "Test User",
		// 	phone: "9517420283",
		// 	specialization: "Urologist",
		// 	problems: '["সমস্যা ২","সমস্যা১"]',
		// },
		// {
		// 	date: "2025-03-12 14:34:39",
		// 	name: "Mahir Labib Dihan",
		// 	phone: "01851953433",
		// 	specialization: "Cardiologist",
		// 	problems: '["উচ্চ রক্তচাপ", "মাথাব্যথা", "মাথা ঘোরা"]',
		// },
		// {
		// 	date: "2025-03-12 14:35:06",
		// 	name: "Mahir Labib Dihan",
		// 	phone: "01851953433",
		// 	specialization: "Cardiologist",
		// 	problems: '["উচ্চ রক্তচাপ", "মাথাব্যথা", "মাথা ঘোরা"]',
		// },
		// {
		// 	date: "2025-03-13 01:25:10",
		// 	name: "Mahir Labib Dihan",
		// 	phone: "01851953433",
		// 	specialization: "Dentist",
		// 	problems: '["Tooth pain", "Possible root canal issue"]',
		// },
	]);

	const TimeConverter = (dateTime24) => {
		const parsedDate = parse(dateTime24, "yyyy-MM-dd HH:mm:ss", new Date());
		const formattedTime = format(parsedDate, "MMMM dd, yyyy, hh:mm:ss a");

		return <div>{formattedTime}</div>;
	};

	const fetchRequests = async () => {
		const result = await api.post(Api.TELEDOC_PROVIDER_API, {
			task: "showPendingMuktiBDAppointmentRequests",
		});

		if (result.success) {
			setRequests(result.data);
		}
		setLoading(false);
	};

	useEffect(() => {
		fetchRequests();
	}, []);

	const [data, setData] = useState([]);
	const [page, setPage] = useState(1);
	const itemsPerPage = 4;
	const pagecount = Math.ceil(requests.length / itemsPerPage);
	useEffect(() => {
		const start = (page - 1) * itemsPerPage;
		const end = Math.min(start + itemsPerPage, requests.length);
		setData(requests.slice(start, end));
	}, [page, requests]);
	const handlePagination = (event, value) => {
		setPage(value);
	};

	return (
		<div className="max-w-2xl px-5 mx-auto  py-3">
			<h1 className="text-3xl font-bold text-center mt-4 mb-6">
				নিয়োগ অনুরোধ
			</h1>
			<div className="flex flex-col items-center w-full gap-4">
				{data.map((request, index) => (
					<Paper elevation={3} className="w-full">
						<div key={index} className=" p-4">
							<h2 className="text-xl font-bold">
								{request.name}
							</h2>
							<p>{request.phone}</p>
							{request.specialization !== "" && (
								<p>
									<u>বিশেষজ্ঞ:</u> {request.specialization}
								</p>
							)}

							<p>
								<u>সমস্যা:</u>{" "}
								{JSON.parse(request.problems)?.map(
									(problem, index) => (
										<span key={index}>
											{problem}
											{index ===
											JSON.parse(request.problems)
												.length -
												1
												? ""
												: ", "}
										</span>
									)
								)}
							</p>
							<p className="w-full text-right">
								{TimeConverter(request.date)}
							</p>
						</div>
					</Paper>
				))}
				<div className="mt-10 flex justify-center bottom-0 left-0 right-0 pt-4">
					<Pagination
						size="medium"
						count={pagecount}
						color="primary"
						onChange={handlePagination}
						siblingCount={1}
						page={page}
					/>
				</div>
			</div>
		</div>
	);
};

export default AppointmentRequests;
